// Core Imports
import { StageOneSVG, StageTwoSVG, StageThreeSVG, StageFourSVG, FragOne, CustomButton } from "../parts/Parts";
import Slider from "react-slick";
import { motion } from "framer-motion";
 
// Vendor Imports
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const Core = () => {

    const componentFourConfig = {
        dots: true,
        arrows: false,
        infinite: true,
        fade: true,
        speed: 1250,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const variants = {
        active: {
            backgroundColor: "#f00"
        },
        inactive: {
            backgroundColor: "#fff",
            transition: { duration: 2 }
        }
    }

    return (

        <div className="component core-component">

            <div className="row core-component--one">
                <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
                    <div className="core-brand-container">
                        <h1>Zachbania.co</h1>
                        <p>Focused on shaping software for society.</p>
                    </div>
                </div>
                <div className="col col-xs-12 col-sm-4 col-md-4 col-lg-4">

                </div>
            </div>


            <div className="row core-component--two">
                <div className="col col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <div className="stage-container">
                        <StageOneSVG />
                    </div>
                    <motion.div className="profile-summary"
                        initial={{ opacity: 0, x: -5 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}>
                        <div className="frag-container">
                            <FragOne />
                        </div>
                        <p className="profile-name">[Zach Bania]</p>
                        <p className="profile-title">[Full Stack Software Developer]</p>
                    </motion.div>
                    <p>Based in Wisconsin, I am a driven software developer with five years of industry experience designing, developing, and maintaining modern digital projects and software documentation.</p>
                </div>
                <div className="col col-xs-12 col-sm-5 col-md-5 col-lg-5">

                </div>
            </div>



            <div className="row core-component--three">
                <div className="col col-xs-12 col-sm-5 col-md-5 col-lg-5">
                    <div className="stage-container">
                        <StageTwoSVG />
                    </div>
                </div>
                <div className="col col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <motion.h2
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >The Scope</motion.h2>
                    <p>Full stack digital projects crafted for reliability, refactored architectures, and user focused functionality.</p>
                    <p>Through an array of different technologies, I shape code and creative visions into digital experiences That drive results.</p>
                    {/* <CustomButton type="alt-white" text="View Stack" to="/" /> */}
                </div>
            </div>

            <div className="row core-component--four">
                <div className="col col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <div className="stage-container">
                        <StageThreeSVG />
                    </div>
                    <Slider {...componentFourConfig}>
                        <div>
                            <motion.h3
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}
                            >Strategy</motion.h3>
                            <p>Having a strategy for a project is important to identify the purpose, vision, and roadmap. Mapping out a projects user interface, required features, and processes running on the platform, creates a strategic and efficient plan for the future of the project.</p>
                        </div>
                        <div>
                            <motion.h3
                                initial={{ opacity: 0, x: -15 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >Design</motion.h3>
                            <p>Prototyping and design documentation are at the core of creating a project vision, and offer an efficient plan for development. They initialize a vision and lay the foundation for a project's user interface and user experience.</p>
                        </div>
                        <div>
                            <motion.h3
                                initial={{ opacity: 0, x: -15 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >Development</motion.h3>
                            <p>Documentation, usability, and maintenance are critical for creating a refactored project architecture. Organization, structure, and code metrics all contribute to the quality and durability of a project.</p>
                        </div>
                        <div>
                            <motion.h3
                                initial={{ opacity: 0, x: -15 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >Deployment</motion.h3>
                            <p>Deploying software includes all the steps, processes, and activities that are required to make a software system available to its intended users. The scope of each project's requirements should be understood, to determine the most optimal deployment strategy.</p>
                        </div>
                    </Slider>
                </div>
                <div className="col col-xs-12 col-sm-5 col-md-5 col-lg-5">

                </div>
            </div>


            <div className="row core-component--five">
                <div className="col col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <div className="stage-container">
                        <StageFourSVG />
                    </div>
                    <motion.h2
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >Case Studies</motion.h2>
                    <p>We let the results do the talking. Each case study, focused on the impact behind the digital experiences we've crafted for our clients.</p>
                    <CustomButton type="alt-white" text="Case Studies" to="/case-studies" />
                </div>
                <div className="col col-xs-12 col-sm-5 col-md-5 col-lg-5">

                </div>
            </div>



        </div>
    );
};

